// Lista de espera: clientes que pidieron un equipo que no estaba libre.
// Cuando se libera, el equipo recibe un aviso en la campana (una sola vez).
import { el, clear } from '../../utils/dom.js';
import { Rentals } from '../../api/resources.js';
import { fmtDateTime } from '../../utils/format.js';
import { ok, err } from '../../components/toast.js';

export default async function EsperaPage(outlet) {
  clear(outlet);
  let lista = [];
  try { lista = await Rentals.espera(); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }
  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {}, el('h1', {}, 'Lista de espera'), el('div', { class: 'muted' }, 'Clientes que quieren un equipo que no estaba libre')),
    el('a', { href: '#/rentals', class: 'btn ghost' }, '← Rentas')));
  if (!lista.length) { outlet.appendChild(el('div', { class: 'card' }, el('p', { class: 'muted' }, 'Nadie está esperando.'))); return; }
  for (const w of lista) {
    const tel = String(w.telefono || '').replace(/\D/g, '');
    const texto = `Hola ${w.nombre.split(' ')[0]}, ya tenemos ${w.equipo} libre para ${fmtDateTime(w.inicio)}. ¿Te lo apartamos?`;
    outlet.appendChild(el('section', { class: 'card mb-3' },
      el('div', { class: 'flex justify-between gap-2 wrap' },
        el('strong', {}, `${w.nombre} · ${w.equipo}`),
        el('span', { class: `badge ${w.libres > 0 ? 'success' : 'muted'}` }, w.libres > 0 ? `${w.libres} libre${w.libres === 1 ? '' : 's'} ahora` : 'Sigue ocupado')),
      el('div', { class: 'text-sm muted' }, `${fmtDateTime(w.inicio)} → ${fmtDateTime(w.fin)}`),
      el('div', { class: 'text-sm' }, [w.telefono, w.email].filter(Boolean).join(' · ')),
      w.notas ? el('div', { class: 'text-sm muted' }, w.notas) : null,
      el('div', { class: 'flex gap-2 wrap mt-3' },
        tel.length >= 10 ? el('a', { class: 'btn primary', target: '_blank', rel: 'noopener',
          href: `https://wa.me/${tel.length === 10 ? '1' + tel : tel}?text=${encodeURIComponent(texto)}` }, 'Avisar por WhatsApp') : null,
        el('a', { class: 'btn', href: '#/rentals/new' }, 'Crear la renta'),
        el('button', { class: 'btn ghost', onclick: async () => {
          try { await Rentals.atenderEspera(w.id); ok('Listo'); EsperaPage(outlet); } catch (ex) { err(ex.message); }
        } }, 'Ya lo atendí'))));
  }
}
